export const GET_TYPE_MOVEMENTS = 'GET_TYPE_MOVEMENTS'
export const GET_TYPE_MOVEMENTS_EXITO = 'GET_TYPE_MOVEMENTS_EXITO'
export const GET_TYPE_MOVEMENTS_ERRROR = 'GET_TYPE_MOVEMENTS_ERROR'
